import React, { Component } from 'react';
import { withAuth } from 'src/common/auth/Auth';
import LoginForm from './LoginForm';
import values from './formValues';
import { FormStore } from 'core/forms/FormStore';
import './login.scss';

const formStore = new FormStore(values);

class Login extends Component {
  render() {
    return (
      <div className="login-page">
        <LoginForm auth={this.props.auth} formStore={formStore} />
      </div>
    );
  }
}

export default withAuth(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/Login.jsx